<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-file-pdf', fontSet: 'fad'}"
	[headerText]="data?.media?.name || data?.mediaName"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<div class="pdfViewerContainer">
			@if (!pdfLoaded && pdfLoadingError) {
				<div class="errorLoading">
					<i class="fad fa-file-pdf fa-3x"></i>
					<div class="text">
						{{ T.EDIT_MEDIA_DIALOG_PDF_LOAD_ERROR | translate }}
					</div>
				</div>
			}

			<sim-component-loading-container
				[isLoading]="!pdfLoaded && !pdfLoadingError"
				[loadingIcon]="'fad fa-file-pdf'"
				[loadingMessage]="T.GLOBAL_TEXT_LOADING | translate"
			/>

			<button (click)="pageNum = pageNum - 1" [disabled]="pageNum === 1" class="controlBtns leftControlBtn" color="accent" mat-fab>
				<mat-icon fontIcon="fa-chevron-left" fontSet="fas" inline style="font-size: 1.2em" />
			</button>

			<sim-document-viewer
				(numberOfPdfPages)="numberOfPdfPages = $event"
				(pdfLoaded)="pdfLoaded = true"
				(pdfLoadingError)="pdfError()"
				[isPreviewMedia]="data?.mediaUrl && data?.mediaUrl.length > 0"
				[media]="data?.media"
				[pageNum]="pageNum"
				[previewMediaUrl]="data?.mediaUrl"
			/>

			<button
				(click)="pageNum = pageNum + 1"
				[disabled]="pageNum === numberOfPdfPages"
				class="controlBtns rightControlBtn"
				color="accent"
				mat-fab
			>
				<mat-icon fontIcon="fa-chevron-right" fontSet="fas" inline style="font-size: 1.2em" />
			</button>
		</div>
	</ng-container>
</sim-basic-material-dialog>
